<!-- 商品推荐列表 -->
<template>
    <div class="main-container">
        <div class="filter-container">
            <!-- 推荐库搜索条件 -->
            <template v-if="type=='1'">
                <el-input class="filter-item" v-model.trim="filters.products_id" placeholder="商品ID" clearable></el-input>
                <el-input class="filter-item" v-model.trim="filters.title" placeholder="商品名称" clearable></el-input>
                <SelectBrand :ifBody="0" @brandChange="onBrandChange"/>
            </template>
            <!-- 被推荐库搜索条件 -->
            <template v-else>
                <el-input class="filter-item" v-model.trim="filters.input_brand_id" placeholder="品牌ID" clearable></el-input>
                <SelectBrand :ifBody="0" @brandChange="onSelectChange"/>
            </template>

            <el-button class="filter-btn" type="primary" @click="onSearch()">搜索</el-button>
            <!-- 推荐库操作 -->
            <template v-if="type=='1'">
                <el-button class="filter-btn" type="primary" @click="router.push('/marketing/recommend-product-edit')">添加商品</el-button>
            </template>
            <!-- 被推荐库操作 -->
            <template v-else>
                <el-button class="filter-btn" type="primary" @click="router.push('/marketing/recommended-brand-edit')">添加品牌</el-button>
                <el-button class="filter-btn" type="primary" @click="onBrandExport">导出</el-button>
            </template>
        </div>

        <el-tabs v-model="type" @tab-change="onTabChange">
            <el-tab-pane label="推荐库" name="1">
                <el-table :data="recommendList" border @selection-change="onRecommendSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <!-- <el-table-column type="index" :index="recommendTableIndex"></el-table-column> -->
                    <el-table-column prop="product_id" label="商品ID"></el-table-column>
                    <el-table-column prop="title" label="商品名称"></el-table-column>
                    <el-table-column prop="brand_name" label="品牌"></el-table-column>
                    <el-table-column prop="market_price" label="市场价"></el-table-column>
                    <el-table-column prop="price" label="售价"></el-table-column>
                    <el-table-column prop="add_time" label="添加时间" width="160"></el-table-column>
                    <el-table-column label="操作">
                        <template #default="scope">
                            <div class="action-list">
                                <el-button type="danger" size="small" @click="onProductDel(scope.row.id)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row justify="space-between" class="mt20">
                    <el-col :span="12">
                        <el-button type="danger" size="small" @click="onProductDel()">删除推荐商品</el-button>
                    </el-col>
                    <el-col :span="12">
                     <Pagination :currentPage="recommendPage" :total="recommendTotal" @pageChange="onRecommendPageChange" @sizeChange="onRecommendSizeChange" />
                        <!-- <el-pagination
                            @current-change="onRecommendPageChange"
                            :currentPage="recommendPage"
                            :page-size="recommendPageSize"
                            layout="total, prev, pager, next, jumper"
                            :total="recommendTotal">
                        </el-pagination> -->
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="被推荐库" name="2">
                <el-table :data="recommendedList" border @selection-change="onRecommendedSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" :index="recommendedTableIndex"></el-table-column>
                    <el-table-column prop="brand_id" label="品牌ID"></el-table-column>
                    <el-table-column prop="name" label="品牌"></el-table-column>
                    <el-table-column prop="product_count" label="商品数量"></el-table-column>
                    <el-table-column prop="status_name" label="状态"></el-table-column>
                    <el-table-column prop="shop_discount" label="品牌折扣"></el-table-column>
                    <el-table-column prop="add_time" label="添加时间" width="160"></el-table-column>
                    <el-table-column label="操作" width="170">
                        <template #default="scope">
                            <div class="action-list">
                                <el-button type="primary" size="small" @click="router.push('/marketing/recommended-product?brand_id='+scope.row.brand_id)">查看商品</el-button>
                                <el-button type="danger" size="small" @click="onBrandDel(scope.row.brand_id)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row justify="space-between" class="mt20">
                    <el-col :span="12">
                        <el-button type="danger" size="small" @click="onBrandDel()">删除被推荐品牌</el-button>
                    </el-col>
                    <el-col :span="12">
                    <Pagination :currentPage="recommendedPage" :total="recommendedTotal" @pageChange="onRecommendedPageChange" @sizeChange="onRecommendedSizeChange" />
                        <!-- <el-pagination
                            @current-change="onRecommendedPageChange"
                            :currentPage="recommendedPage"
                            :page-size="recommendedPageSize"
                            layout="total, prev, pager, next, jumper"
                            :total="recommendedTotal">
                        </el-pagination> -->
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated } from 'vue'
import { useStore } from '@/store/index'
import { getBrandListApi } from '@/apis/brand'
import { getRecommendList, delRecommendProduct, getRecommendedBrandList, delRecommendedBrand } from '@/apis/recommend'
import { joinParams } from '@/utils'
import SelectBrand from '@/components/SelectBrand.vue'
import Keys from '@/constant/key'
export default defineComponent({
name: 'ProductRecommend',
components: {SelectBrand,Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()

    const state = reactive({
        user_id: store.state.user.userInfo.id,
        type:   '1',    // 列表类型
        filters: {
            products_id:            '',     // 商品ID
            title:                  '',     // 商品名称
            selected_brand_id:      '',     // 推荐商品下拉选择选中的品牌ID
            input_brand_id:         '',     // 品牌ID
            selected_brand_id_01:   '',     // 被推荐品牌下拉选择选中的品牌ID
        },
        brandList: [], // 品牌列表,用于搜索

        /******* 推荐库 *******/
        recommendList:      [], // 推荐库列表
        selectedProducts:   [], // 已选中商品
        recommendPage:      1,  // 推荐库列表当前页码
        recommendPageSize:  10, // 推荐库列表每页条数
        recommendTotal:     0,  // 推荐库列表总条数
        // 表格 index 连续
        recommendTableIndex: (index) => {
            return (state.recommendPage - 1) * state.recommendPageSize + index + 1
        },
        // 选中监听
        onRecommendSelectionChange: (val) => {
            state.selectedProducts = val
        },
        onProductDel: (ids = '') => {
            // 没有传 brand_ids 表示要批量删除
            if (!ids) {
                const { selectedProducts } = state
                if (selectedProducts.length === 0) return proxy.$message({ type: 'error', message: '请至少选择一记录' })
                selectedProducts.map(item => {
                    ids += `,${item.id}`
                })
                ids = ids.substring(1, ids.length)
            }

            // 请求接口删除数据
            proxy.$confirm(`确定要删除${ids ? '此批' : '该'}品牌吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                delRecommendProduct(ids).then(res => {
                    const {code, data, msg} = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '删除成功' })
                    getRecommendListFn()
                })
            }).catch(() => {
                console.log('取消批量删除被推荐品牌')
            })
        },
        // 切页
        onRecommendPageChange: (val) => {
            state.recommendPage = val
            getRecommendListFn()
        },
        onRecommendSizeChange:  (val) => {
            state.recommendPageSize = val
            getRecommendListFn()
        },

        /******* 被推荐库 *******/
        recommendedList:        [], // 推荐库列表
        selectedBrands:         [], // 已选中品牌
        recommendedPage:        1,  // 推荐库列表当前页码
        recommendedPageSize:    10, // 推荐库列表每页条数
        recommendedTotal:       0,  // 推荐库列表总条数
        // 表格 index 连续
        recommendedTableIndex: (index) => {
            return (state.recommendedPage - 1) * state.recommendedPageSize + index + 1
        },
        onBrandChange (val) {
            state.filters.selected_brand_id = val
        },
        onSelectChange (val) {
            state.filters.selected_brand_id_01 = val
        },
        // 选中监听
        onRecommendedSelectionChange: (val) => {
            state.selectedBrands = val
        },
        // 批量删除被推荐品牌
        onBrandDel: (brand_ids = '') => {
            // 没有传 brand_ids 表示要批量删除
            if (!brand_ids) {
                const { selectedBrands } = state
                if (selectedBrands.length === 0) return proxy.$message({ type: 'error', message: '请至少选择一记录' })
                selectedBrands.map(item => {
                    brand_ids += `,${item.brand_id}`
                })
                brand_ids = brand_ids.substring(1, brand_ids.length)
            }

            // 请求接口删除数据
            proxy.$confirm(`确定要删除${brand_ids ? '此批' : '该'}品牌吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                delRecommendedBrand(brand_ids).then(res => {
                    const {code, data, msg} = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '删除成功' })
                    getRecommendedListFn()
                })
            }).catch(() => {
                console.log('取消批量删除被推荐品牌')
            })
        },
        // 被推荐库导出
        onBrandExport: () => {
            const { filters, selectedBrands } = state
            const { input_brand_id, selected_brand_id_01 } = filters
            let brand_ids = selectedBrands.map(item => item.brand_id)
            window.open(`${Keys.baseUrl}/relevance/relevance_brand_export?${joinParams({brand_ids: input_brand_id || selected_brand_id_01 || brand_ids.join(',') })}`)
        },
        // 切页
        onRecommendedPageChange: (val) => {
            state.recommendedPage = val
            getRecommendedListFn()
        },
        onRecommendedSizeChange: (val) => {
            state.recommendedPageSize = val
            getRecommendedListFn()
        },
        // 搜索
        onSearch: () => {
            if (state.type == '1') {
                state.recommendPage = 1
                getRecommendListFn()
            } else {
                state.recommendedPage = 1
                getRecommendedListFn()
            }
        },
        // 标签切换
        onTabChange: () => {
            const { type } = state.filters
            type === '1' ? getRecommendListFn() : getRecommendedListFn()
        }
    })

    const initData = () => {
        getBrandListFn()
        getRecommendListFn()
    }

    // 获取品牌列表
    const getBrandListFn = async () => {
        const {code, data, msg} = await getBrandListApi()
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        state.brandList = data
    }
    // 获取推荐列表
    const getRecommendListFn = async () => {
        const { filters, recommendPage:page, recommendPageSize:page_size} = state
        const { products_id, title, selected_brand_id:brand_id } = filters
        const { code, data, msg } = await getRecommendList({
            products_id,
            title,
            brand_id,
            page,
            page_size
        })
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        const { data:list, total } = data
        state.recommendList = list
        state.recommendTotal = total
    }
    // 获取被推荐列表
    const getRecommendedListFn = async () => {
        const { filters, recommendedPage:page, recommendedPageSize:page_size} = state
        const { input_brand_id, selected_brand_id_01 } = filters
        const {code, data, msg} = await getRecommendedBrandList({
            brand_id: input_brand_id || selected_brand_id_01,
            page,
            page_size
        })
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        const { data:list, total } = data
        state.recommendedList = list
        state.recommendedTotal = total
    }

    initData()

    onActivated (() => {
        state.type == '1' ? getRecommendListFn() : getRecommendedListFn()
    })
    return { ...toRefs(state),  store, router }
}
})
</script>